import { navigate } from 'gatsby'
import { isLoggedInVar, pushMoneyUserVar } from '../cache'
import { LOGIN_ROUTE } from '../providers/routes'
import LocalStorageManager from './localStorageManager'

/**
 * Manejo de sesion invalida o expirada (AD-6550).
 *
 * El backend responde REQUIRED_USER_SESSION (code 1401) cuando el token falta,
 * vencio o el usuario ya no esta activo. Como lo lanza al crear el contexto,
 * llega con HTTP 500: el error puede venir en graphQLErrors o dentro de
 * networkError.result.errors, por eso se revisan los dos.
 */
export const SESSION_EXPIRED_KEY = 'sessionExpired'

const SESSION_ERROR_TYPE = 'REQUIRED_USER_SESSION'
const SESSION_ERROR_CODE = '1401'

export const isSessionError = error =>
  error?.extensions?.type === SESSION_ERROR_TYPE ||
  String(error?.extensions?.code) === SESSION_ERROR_CODE

/**
 * @param {{graphQLErrors?: Array, networkError?: object}} apolloError
 * @returns {object|undefined} el error de sesion, si lo hay
 */
export const findSessionError = ({ graphQLErrors, networkError } = {}) =>
  [...(graphQLErrors || []), ...(networkError?.result?.errors || [])].find(
    isSessionError,
  )

/**
 * Cierra la sesion local y lleva al Login.
 *
 * Antes, al fallar la carga del Home se limpiaba el localStorage pero
 * isLoggedInVar quedaba en true y no se navegaba: el usuario veia un Home
 * vacio con el menu habilitado y recien al tocar una opcion terminaba en el
 * Login.
 *
 * @param {{expired?: boolean}} options expired: muestra en el Login el aviso
 *   de sesion expirada.
 */
export function endSession({ expired = false } = {}) {
  isLoggedInVar(null)
  pushMoneyUserVar(null)
  LocalStorageManager.clear()

  if (typeof window === 'undefined') return

  if (expired) {
    // Igual que en el bloqueo de cuenta (providers/apollo): evita el reload
    // automatico del Login (checkReload), que haria perder el aviso.
    LocalStorageManager.setItem('reloaded', 'true')
    try {
      window.sessionStorage.setItem(SESSION_EXPIRED_KEY, 'true')
    } catch (err) {
      // Sin sessionStorage solo se pierde el aviso; la redireccion sigue.
    }
  }
  navigate(LOGIN_ROUTE)
}
